<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px" transition="dialog-transition">
    <v-card>
      <v-card-title>
        <span class="headline">Editando grupo econômico do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-select
          v-model="selectedEconomicGroupId"
          :items="economicGroupsOptions"
          item-text="name"
          item-value="id"
          label="Grupo econômico"
          clearable
          placeholder="Nenhum grupo"
        ></v-select>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel @click="closeDialog"></f-btn>
        <f-btn save :loading="saving" @click="emitUpdate"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Api from '@/api/index'

export default {
  name: 'ClientEditEconomicGroupDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    client: {
      type: Object,
      default: null,
    },
    economicGroups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedEconomicGroupId: null,
      saving: false,
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    economicGroupsOptions() {
      return (this.economicGroups || []).map((item) => {
        let rawId = item.id != null ? item.id : item.attributes?.id
        let id = rawId != null ? Number(rawId) : null
        let name = item.attributes?.name ?? item.name ?? ''
        return { id, name }
      }).filter((opt) => opt.id != null && opt.name !== undefined && opt.name !== null)
    },
  },
  methods: {
    closeDialog() {
      this.$emit('close')
    },
    emitUpdate() {
      let clientId = Number(this.client?.data?.id)
      this.saving = true
      Api.Client.updateEconomicGroup(this.selectedEconomicGroupId, clientId)
        .then(() => {
          this.addNotification({ type: 'success', msg: 'Grupo econômico atualizado com sucesso.' })
          this.$emit('update', { economic_group_id: this.selectedEconomicGroupId })
          this.closeDialog()
        })
        .catch((err) => {
          let msg = err?.response?.data?.errors?.[0] || err?.message || 'Erro ao atualizar grupo econômico.'
          this.addNotification({ type: 'error', msg })
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
  watch: {
    value(open) {
      if (open) {
        let current = this.client?.data?.attributes?.economic_group_id
        this.selectedEconomicGroupId = current != null && current !== '' ? Number(current) : null
      }
    },
  },

}
</script>
